import { PageTemplateFragment } from '@scentregroup/shared/graphql'
import { SGPageTemplateWithAdZones } from '@scentregroup/shared/types/page-templates'
import { parseModule } from './module'

export default function parse(
  template: PageTemplateFragment,
  centreName?: string
): SGPageTemplateWithAdZones {
  const updatedTitle = centreName
    ? template.title.replace('{centreName}', centreName)
    : template.title
  return {
    title: updatedTitle,
    shortDescription: template.shortDescription,
    modules: template.modules.flatMap(parseModule),
  }
}
